<template>
  <div class="container_presentation" v-if="course.name">
    <div class="spacer"></div>
    <div class="spacer"></div>
    <b-container>
      <b-row>
        <b-col md="3" class="side_logo_container">
          <img class="side_logo" src="@/assets/img/logo_rectangle_sm.png" alt="Logo challenge maritima" />
        </b-col>
        <b-col md="6">
          <h2 style="font-weight: bold">{{ course.name }} - {{ course.distance }}</h2>
          <h4>{{ course.date }}</h4>
        </b-col>
        <b-col md="3" class="side_logo_container">
          <img class="side_logo" src="@/assets/img/Logo_TotalEnergies.png" alt="Logo Total energies" />
        </b-col>
      </b-row>
      <b-row>
        <b-col offset-md="3" md="6">
          <div class="spacer"></div>
          <img src="@/assets/img/courses/parcours_castillon.jpg" alt="" />
          <div class="spacer"></div>
          <p>
            C'est à Port-de-Bouc, dans la forêt de Castillon, que sera lancé le Challenge Maritima 2023. Une première bouffée d'air frais dans le calendrier 2023 qui se divise cette année en deux catégories : nature et route. Des centaines de
            coureurs sont attendus au départ dimanche.
          </p>
        </b-col>
      </b-row>
      <div class="spacer"></div>
      <div class="spacer"></div>
      <b-row>
        <b-col md="2"> </b-col>
        <b-col md="4">
          <img src="@/assets/img/courses/castillon_1.jpg" alt="" />
        </b-col>
        <b-col md="4">
          <img :src="'https://sportips.fr/challenge-maritima/img/flyer/' + course.url_flyer" alt="" />
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <!-- <p><b>Contact : Jean Paul 06 06 06 06 06</b></p> -->
        </b-col>
      </b-row>
      <div class="spacer"></div>
      <b-row>
        <b-col>
          <b-button class="infos_btn" href="https://lafouleepdb.wixsite.com/fouleeportdeboucaine/10kmcastillon" target="_blank">Infos course</b-button>
          <b-button class="infos_btn" href="https://www.courirenfrance.com/" target="_blank">Inscriptions</b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: ["course"],
  created() {},
};
</script>

<style lang="scss" scoped>
</style>